import React from "react";
import ViewScreenshotThumbnail from "../../../../../../components/ViewScreenshotThumbnail";

interface PreviewEmailProps {
  onClick: () => void;
  screenshotPath: string;
}

const PreviewEmailButton: React.FC<PreviewEmailProps> = ({
  onClick,
  screenshotPath
}) => (
  <>
    {screenshotPath ? (
      <ViewScreenshotThumbnail
        thumbnailTitle="Open Preview"
        errorTitle="Preview Email Body"
        srcPath={screenshotPath}
        onClick={onClick}
      />
    ) : (
      <ViewScreenshotThumbnail
        thumbnailTitle="Open Preview"
        errorTitle="Preview Email Body"
        srcPath={`${window.tcbase.urls.static}/images/code.svg`}
        placeholderImageStyle={{ width: "50%", margin: "auto" }}
        onClick={onClick}
      />
    )}
  </>
);

export default PreviewEmailButton;
